module.exports = __webpack_public_path__ + "media/images/user/favicons/apple-touch-icon-57x57-precomposed-c9508800d9cb2940a1f7feed0459549d.png";